import { render, staticRenderFns } from "./MedicalRecordAdd.vue?vue&type=template&id=0473fbb8&"
import script from "./MedicalRecordAdd.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports